export default '/build/41bd2f07.png'